import Dialog from 'global/guides/Dialog'

interface IProps {
    open: boolean
}

export default function DialogSucesso({ open }: IProps) {
    return (
        <Dialog.Root open={open} width="auto" height="auto">
            <Dialog.Title>Configuração salva com sucesso!</Dialog.Title>
            <Dialog.Content>
                <p>
                    As alterações foram salvas com sucesso. Por favor, recalcule
                    essa competência
                </p>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
